<template>
  <div class="criterio-ticket-range">
    <span class="criterio-subtitle">{{ label }}</span>

    <v-layout class="container-cumpon-range">
      <v-flex class="d-flex" cols="12" sm="12">
        <p>
          <span> de </span>
          <v-text-field
            v-model="firstValue"
            v-mask="inputMask"
            :disabled="disabled"
            solo
            hide-details
            @input="input"
            @keypress="($evt) => isNumber($evt, 'firstValue')"
          />
        </p>
        <p>
          <span> até </span>
          <v-text-field
            v-model="secondValue"
            v-mask="inputMask"
            :disabled="disabled"
            solo
            hide-details
            @input="input"
            @keypress="($evt) => isNumber($evt, 'secondValue')"
          />
        </p>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
export default {
  props: {
    label: String,
    currentIndex: Number,
    initialValue: {},
    values: {},
    componentParams: String,
    disabled: {
      type: Boolean,
      default: false,
    },
  },

  data: () => ({
    firstValue: null,
    secondValue: null,
    timeout: null,
  }),

  computed: {
    firstValueNumber() {
      if (!this.firstValue) return 0
      if (typeof this.firstValue === 'number') return Number(this.firstValue)
      return Number(this.firstValue.replace(',', '.'))
    },
    secondValueNumber() {
      if (!this.secondValue) return 0
      if (typeof this.secondValue === 'number') return Number(this.secondValue)
      return Number(this.secondValue.replace(',', '.'))
    },
  },

  mounted() {
    this.getData()
  },

  methods: {
    input() {
      window.clearTimeout(this.timeout)
      this.timeout = window.setTimeout(() => {
        this.$emit('input', { currentValue: [this.firstValueNumber, this.secondValueNumber], currentIndex: this.currentIndex })
        this.validate()
      }, 500)
    },

    async validate() {
      this.$emit('validate', { isValid: await this.isValid(), currentIndex: this.currentIndex })
    },

    isValid() {
      return this.firstValueNumber < this.secondValueNumber
    },

    isNumber(evt, valueHandle) {
      evt = evt || window.event
      const alreadyHaveSeparator = this[valueHandle] && (this[valueHandle].includes(',') || this[valueHandle].includes(','))
      if (evt.key >= '0' && evt.key <= '9') {
        return true
      } else if (!alreadyHaveSeparator && (evt.key === ',' || evt.key === '.')) {
        return true
      } else {
        evt.preventDefault()
      }
    },

    getData() {
      if (this.initialValue) {
        this.firstValue = this.initialValue[0]
        this.secondValue = this.initialValue[1]
      }
      this.validate()
    },
  },
}
</script>

<style lang="scss">
.criterio-ticket-range {
  margin-top: 24px;

  .criterio-subtitle {
    font-size: 16px;
  }

  .container-cumpon-range {
    margin-top: 10px;

    p:nth-child(1) {
      margin-right: 15px;
    }
  }
}
</style>
